/* 
Common code for each of the views making up the notice template page.
*/
import lookupMixins from "@/mixins/lookup.mixins";
import * as ntAction from "@/store/notice-templates/action-types";
import * as claim from "@/store/claim-types";

export default {
  mixins: [lookupMixins],
  computed: {
    levyCollectionId() {
      return parseInt(this.$route.params.levyCollectionId);
    },
    noticeType() {
      return this.$route.params.noticeType;
    },
    title() {
      return this.lookupsLoaded ? `${this.lookups.noticeTypeDescriptions[this.noticeType]} template` : "...";
    },
    breadcrumbs() {
      return this.$store.state.noticeTemplates.view.breadcrumbs;
    },
    loaded() {
      return this.$store.state.noticeTemplates.view.loaded;
    },
    canEdit() {
      return (
        this.$store.state.noticeTemplates.view.data.levyCollectionStatus != "Finalised" &&
        this.$store.getters.claims.includes(claim.NOTICE_TEMPLATES_EDIT)
      );
    }
  },
  watch: {
    noticeType() {
      this.reload();
    },
    levyCollectionId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.$store.dispatch(ntAction.VIEW_REFRESH, {
        levyCollectionId: this.levyCollectionId,
        noticeType: this.noticeType
      });
    }
  }
};
